export default __webpack_public_path__ + "static/media/ldo_FLOAT_ADJ_nEN_Cff.405251f7.svg";